export const PRODUCTS = {
  DIGITAL: {
    key: "digital",
    variantMedium: "Digital"
  },
  PHYSICAL: {
    key: "greyResin",
    variantMedium: "Grey+Resin"
  }
  //COLOR: { key: "color", displayName: "Color" }
};
